/**
 * Resolves API currencyCode for a batch posting row.
 * Uses company base currency; when Client Multi-Currency is enabled,
 * some posting types use the selected bank nominal's currency when it differs from base.
 */
export function resolvePostingCurrencyCode(data, company) {
  const baseCurrency = company?.baseCurrency;
  const clientMultiCurrency = Boolean(
    company?.modules?.ClientMultiCurrency ??
      company?.Modules?.ClientMultiCurrency,
  );

  if (!clientMultiCurrency) {
    return baseCurrency;
  }

  const code = data?.postingType?.code;

  if (code === "CCR" || code === "CDR" || code === "OTC") {
    const bankCur = data?.clientBank?.currencyCode;
    if (bankCur && bankCur !== baseCurrency) {
      return bankCur;
    }
    return baseCurrency;
  }

  if (code === "DCR" || code === "DDR") {
    const bankCur = data?.ddaBank?.currencyCode;
    if (bankCur && bankCur !== baseCurrency) {
      return bankCur;
    }
    return baseCurrency;
  }

  if (code === "CTC") {
    const bankCur =
      data?.clientBankFrom?.currencyCode || data?.clientBankTo?.currencyCode;
    if (bankCur && bankCur !== baseCurrency) {
      return bankCur;
    }
    return baseCurrency;
  }

  // CTO / OTC and all other types: client bank restricted to base for CTO in UI; payload uses base.
  return baseCurrency;
}
